<template>
    <v-dialog
            :value="shownRelay"
            :persistent="true"
            width="400"
    >
        <v-card>
            <v-progress-linear
                    v-if="savingChanges"
                    color="primary"
                    indeterminate
            ></v-progress-linear>

            <v-card-title class="dlg-title-bar">
                Add New Team
            </v-card-title>

            <v-card-text class="pt-3">

                <v-form ref="createTeamForm" @submit="$event.preventDefault()">
                    <v-text-field
                            dense
                            outlined
                            color="primary"
                            v-model="value.name"
                            label="Team Name"
                            placeholder="eg. Accounting"
                            :rules="[validationRules.required, duplicateTeamName]"
                            :readonly="savingChanges"
                            ref="teamName"
                    >
                    </v-text-field>
                    <v-autocomplete
                            dense
                            outlined
                            color="primary"
                            v-model="addEmployees"
                            label="Employees"
                            placeholder="eg. Mortey Smith"
                            :items="availableEmployees"
                            item-text="name"
                            item-value="_id"
                            chips
                            small-chips
                            deletable-chips
                            multiple
                            v-if="showEmployees"
                    >
                    </v-autocomplete>
<!--                    <v-autocomplete-->
<!--                            dense-->
<!--                            outlined-->
<!--                            color="primary"-->
<!--                            v-model="value.userIds"-->
<!--                            label="Limit User access"-->
<!--                            placeholder="All Users"-->
<!--                            :items="users"-->
<!--                            item-text="name"-->
<!--                            item-value="_id"-->
<!--                            chips-->
<!--                            small-chips-->
<!--                            deletable-chips-->
<!--                            multiple-->
<!--                    >-->

<!--                        <template v-slot:item="{item}">-->
<!--                            <v-list-item-avatar>-->
<!--                                <v-icon>mdi-badge-account</v-icon>-->
<!--                            </v-list-item-avatar>-->
<!--                            <v-list-item-content>-->
<!--                                <v-list-item-title v-text="item.name"/>-->
<!--                                <v-list-item-subtitle v-text="item.username"/>-->
<!--                            </v-list-item-content>-->
<!--                        </template>-->
<!--                    </v-autocomplete>-->
                </v-form>

            </v-card-text>
            <v-divider/>

            <v-card-actions>
                <v-spacer/>
                <v-btn
                        class="ml-2"
                        small
                        color="primary"
                        @click="shownRelay = false"
                        outlined
                        size="small"
                        :disabled="savingChanges"
                >
                    Cancel
                </v-btn>

                <v-btn
                        @click="createTeam"
                        small
                        class="ml-2"
                        color="secondary"
                        variant="contained"
                        size="small"
                        :disabled="savingChanges"
                        :loading="savingChanges"
                >
                    Add New Team
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {Employee} from "@/models/employee";
import {validationRules} from "@/core/codeFunctions";
import {mapGetters} from "vuex";
import {Team} from "@/models/team";

export default {
    props: {
        shown: Boolean,
        showEmployees: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            savingChanges: false,
            value: new Team({}),
            validationRules: validationRules,
            addEmployees: [],
        }
    },
    watch: {
        shown: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.addEmployees = []
                    setTimeout(() => {
                        this.$refs.teamName.focus()
                    }, 500)
                }
            }
        }
    },
    methods: {

        async createTeam() {
            if (!this.$refs.createTeamForm.validate())
                return;
            try {
                this.savingChanges = true;
                const {_id} = await this.value.create(this.addEmployees);
                const addedTeam = await this.teams.once(_id)
                this.$emit('input', addedTeam)
                this.shownRelay = false
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.savingChanges = false
            }
        },

        duplicateTeamName(val) {
            if (!val)
                return 'Required value'
            const teamNames = this.teams.map(emp => (emp.name || '').toLowerCase())
            if (teamNames.includes((val || '').toLowerCase()))
                return 'Team name has already been used'
            return true
        }
    },
    computed: {
        ...mapGetters(['employees', 'teams', 'users']),
        availableEmployees() {
            return this.employees.filter(emp => !emp.teamId && !emp.disabled)
        },
        shownRelay: {
            get() {return this.shown},
            set(val) {this.$emit('update:shown', val)}
        }
    },
}
</script>

<style scoped>

</style>